import { render } from "./Effect_information.vue?vue&type=template&id=565ae164"
import script from "./Effect_information.vue?vue&type=script&lang=js"
export * from "./Effect_information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__